import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appBestPriceTooltip]',
  standalone: false
})
export class BestPriceTooltipDirective {
  @Input() isBestPriceTooltipVisible = false;
  @Input() bestPriceTooltipIndex: number;
  @Input() index: number;
  @Input() isMobile: boolean;
  @Output() bestPriceTooltipVisibleEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() indexValueEvent: EventEmitter<number> = new EventEmitter();
  @Output() trackBestPriceTooltip: EventEmitter<boolean> = new EventEmitter();

  constructor(private readonly el: ElementRef) {
    el.nativeElement.addEventListener('mouseenter', (e) => {
      if (!this.isMobile) {
        this.isBestPriceTooltipVisible = true;
        this.bestPriceTooltipIndex = this.index;
        this.bestPriceTooltipVisibleEvent.emit(this.isBestPriceTooltipVisible);
        this.indexValueEvent.emit(this.bestPriceTooltipIndex);
        this.trackBestPriceTooltip.emit(this.isBestPriceTooltipVisible);
      }
    });
    el.nativeElement.addEventListener('mouseleave', (e) => {
      if (!this.isMobile) {
        this.isBestPriceTooltipVisible = false;
        this.bestPriceTooltipIndex = null;
        this.bestPriceTooltipVisibleEvent.emit(this.isBestPriceTooltipVisible);
        this.indexValueEvent.emit(this.bestPriceTooltipIndex);
      }
    });
    el.nativeElement.addEventListener('click', (e) => {
      if (this.isMobile) {
        this.isBestPriceTooltipVisible = !this.isBestPriceTooltipVisible;
        this.bestPriceTooltipIndex = this.index;

        this.bestPriceTooltipVisibleEvent.emit(this.isBestPriceTooltipVisible);
        this.indexValueEvent.emit(this.bestPriceTooltipIndex);

        if (this.isBestPriceTooltipVisible) {
          this.trackBestPriceTooltip.emit(this.isBestPriceTooltipVisible);
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
  }

  @HostListener('window:scroll', [])
  onScroll() {
    this.isBestPriceTooltipVisible = false;
    this.bestPriceTooltipIndex = null;
    this.bestPriceTooltipVisibleEvent.emit(this.isBestPriceTooltipVisible);
    this.indexValueEvent.emit(this.bestPriceTooltipIndex);
  }
}
